import { observer } from 'mobx-react-lite'
import {useParams} from "react-router-dom";
import controller from './__admin'
import React, { useEffect } from 'react'
import i from "../../../translations/i";
import {Titles} from "../../../layouts/Titles";
import {Button, Space, Table, Tooltip} from "antd";
import dayjs from "dayjs";
import {SettingOutlined} from "@ant-design/icons";

export const CuratorUsers = observer(() => {

    let { id }: any = useParams()

    useEffect(() => {
        return () => {
            controller.admin.id = id
            controller.getUsersByCurator()
        }
    }, [id])

    const columns = [
        {
            title: "ID",
            key: 'id',
            dataIndex: 'id',
        },
        {
            title: i.t('users:name'),
            key: 'name',
            render: (record: any) => `${record.firstname ?? ''} ${record.lastname ?? ''} ${record.surname ?? ''}`
        },
        {
            title: i.t('users:email'),
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: i.t('users:phone'),
            dataIndex: 'phone',
            key: 'phone'
        },
        {
            title: i.t('users:count_payed_orders'),
            dataIndex: 'count_payed_orders',
            render: (date: number) => date
        },
        {
            title: i.t('users:last_order_date'),
            dataIndex: 'last_order_date',
            render: (date: any) => date ? dayjs(date).format("DD.MM.YYYY") : ''
        },
        {
            title: i.t('users:birthday'),
            dataIndex: 'birthday',
            render: (date: any) => date > 0 ? dayjs(date*1000).format("DD.MM.YYYY") : ''
        },
        {
            title: i.t('points:actions'),
            key: 'action',
            render: (text: any, record: any) => (
                <>
                    <Space>
                        <Tooltip title={i.t('def:actions.edit')}>
                            <Button
                                type="dashed"
                                icon={<SettingOutlined />}
                                href={`/users/${record.id}`}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ]

    return (
        <>
            <Titles
                title="Привязанные партнеры"
                buttons={[
                    { title: "Вернуться", href: `/settings/managers/${id}`, type: 'dashed' },
                ]}
            />

            <Table
                columns={columns}
                dataSource={controller.partners.data}
                rowKey="id"
                pagination={{
                    total: controller.partners.total,
                    current: controller.partners.page,
                    pageSize: 100,
                    onChange: (page) => {
                        controller.getUsersByCurator(page)
                    }
                }}
            />
        </>
    )
})